module.exports = __webpack_public_path__ + "static/media/logo4.7f66c913.jpeg";